import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireObject } from 'angularfire2/database';
import { Product } from 'shared/models/product';
import { take, map } from 'rxjs/operators';
import { ShoppingCart } from 'shared/models/shopping-cart';
import { Observable } from 'rxjs';
import { ShoppingCartItem } from 'shared/models/shopping-cart.item';

@Injectable({
  providedIn: 'root'
})
export class ShoppingCartService {
  selectedItem;
  
  constructor(private db: AngularFireDatabase) { }

  async getCart(): Promise<Observable<ShoppingCart>> {
    let cartId = await this.getOrCreateCartId()
    return this.db.object('/shopping-carts/' + cartId + '/items')
      .snapshotChanges().pipe(map(x => new ShoppingCart(x.payload.val() as { [productId: string]: ShoppingCartItem})));
  }

  async addToCart(product: Product) {
    this.updateItem(product, 1);
  }

  async removeFromCart(product: Product) {
    this.updateItem(product, -1);
  }

  async clearCart() {
    let cartId = await this.getOrCreateCartId();
    this.db.object('/shopping-carts/' + cartId + '/items').remove();
  }

  private create() {
    return this.db.list('/shopping-carts').push({
      dateCreated: new Date().getTime()
    });
  }

  private getItem(cartId: string, productId: string) {
    return this.db.object('/shopping-carts/' + cartId + '/items/' + productId);
  }

  private async getOrCreateCartId(): Promise<string> {
    let cartId = localStorage.getItem('cartId');
    if (cartId) return cartId;

    let result = await this.create();
    localStorage.setItem('cartId', result.key);
    return result.key;
  }

  private async updateItem(product: Product, change: number) {
    let cartId = await this.getOrCreateCartId();

    let items$ = this.getItem(cartId, product.$key);

    items$.snapshotChanges().pipe(take(1)).subscribe(item => {
      // if(item.payload.exists()) items$.update({ quantity: (item.payload.val() as {product: Product, quantity: number}).quantity + change });
      // else items$.set({ product: product, quantity: 1});

      let quantity = item.payload.val() ? (item.payload.val() as { quantity: number}).quantity + change : 1;

      if(quantity === 0) items$.remove();
      else items$.update({ 
        title: product.title,
        imageUrl: product.imageUrl,
        price: product.price,
        quantity: quantity });
    });
  }
}
